import { NgForOf } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-item-rating',
  standalone: true,
  imports: [
    NgForOf
  ],
  templateUrl: './item-rating.component.html',
})
export class ItemRatingComponent implements OnInit, OnChanges {
  @Input() reviewsCount: number | undefined = 0;
  @Input() averageRating: number | undefined = 0;
  stars: any;

  ngOnInit() {
    // this.stars = this.generateStars(this.averageRating);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.averageRating){
      this.stars = this.generateStars(this.averageRating);
    }
  }

  generateStars(rating: number | undefined): string[] {
    const stars: string[] = [];
    // Return empty array if rating is undefined or out of range
    if (rating === undefined || rating < 0 || rating > 5) {
      return stars;
    }
    const integerPart = Math.floor(rating);
    const decimalPart = rating % 1;
    for (let i = 1; i <= 5; i++) {
      if (i <= integerPart) {
        // Full star if the integer part is greater than or equal to the star index
        stars.push('assets/icons/rating/icon-star-fill.svg');
      } else if (i - 1 === integerPart) {
        // Check the decimal part only for the current star
        if (decimalPart < 0.3) {
          stars.push('assets/icons/rating/icon-star-outline.svg'); // Empty star
        } else if (decimalPart < 0.7) {
          stars.push('assets/icons/rating/icon-star-half.svg'); // Half star
        } else {
          stars.push('assets/icons/rating/icon-star-fill.svg'); // Full star
        }
      } else {
        // Empty star for all remaining stars
        stars.push('assets/icons/rating/icon-star-outline.svg');
      }
    }
    return stars;
  }

}
